<template>
  <div class="post-content">
    <div
      v-if="post.opinion"
      class="bazar-voice"
    >
      <p class="dark">Avis authentiques</p>
      <div class="light">
        <img
          src="~assets/icons/bazarvoice.svg"
          alt="bazar voice"
          width="15"
          height="14"
        />
      </div>
    </div>
    <div
      v-if="source"
      class="source-content"
    >
      <h1 class="type">
        {{ post.type }} <span>{{ post.title }}</span>
      </h1>
      <div class="title-post">
        <p class="title">{{ post.title }}</p>
        <img
          v-if="post.pegi"
          class="pegi_img"
          :src="`/icons/PEGI_${post.pegi}.svg`"
          :alt="`pegi ${post.pegi}`"
          width="37"
          height="46"
        />
      </div>
      <p
        class="description"
        @click="onChapterClick"
        v-html="sourceDescription"
      />
      <a
        :href="post.url"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="link"
        @click="clickPostLink"
      >
        {{ post.url }}
      </a>
      <p
        v-if="post.sourceAuthor"
        class="source-author"
      >
        {{ sharedVideo ? 'Vidéo de' : 'Contenu de' }}
        <a
          v-if="post.sourceAuthorUrl"
          :href="post.sourceAuthorUrl"
          target="_blank"
          rel="noopener noreferrer nofollow"
          >{{ post.sourceAuthor }}</a
        >
        <template v-else>{{ post.sourceAuthor }}</template>
      </p>
    </div>
    <div class="author">
      <h2 class="title-strat">posté par</h2>
      <div class="waper">
        <NuxtLink
          :to="`/wapers/${post.user?.slug}`"
          class="img-container"
        >
          <NuxtImg
            v-if="post.user?.avatar"
            :src="post.user.avatar.url"
            :alt="`photo de profil de ${post.user.nickname}`"
            width="168"
            height="168"
            loading="lazy"
            quality="80"
            fit="cover"
            format="auto"
          />
        </NuxtLink>
        <div class="right-content">
          <NuxtLink
            class="infos-container"
            :to="`/wapers/${post.user?.slug}`"
          >
            <p class="name">
              {{ readMore(capitalize(post.user?.nickname), 25) }}
            </p>
            <p
              v-if="post.user?.points_total"
              class="points"
            >
              {{ post.user.points_total }} points
            </p>
          </NuxtLink>
          <div
            v-if="
              auth.data.value
                ? auth.data.value.nickname != post.user?.nickname
                : true
            "
            class="button-container"
          >
            <div
              v-if="post.followed"
              class="button sub"
              @click="tryUnfollow"
            >
              Suivi
              <img
                src="~assets/icons/check.svg"
                alt="check"
                class="check"
              />
            </div>
            <div
              v-else
              class="button no-sub"
              @click="tryFollow"
            >
              Suivre
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!source && post.urlVideo"
      class="main-iframe"
    >
      <VideoFacade
        :src="cover"
        :title="post.title"
        class="p-video__iframe"
      />
    </div>
    <div
      v-if="!source && !post.opinion"
      class="content"
      v-html="contentParsed"
    />
    <div
      v-if="post.createdAt"
      class="date"
    >
      Publié le
      <time :datetime="post.createdAt">
        {{ datePublication(post.createdAt) }}
      </time>
      <template v-if="updatedLater">
        · mis à jour le
        <time :datetime="post.updatedAt">
          {{ datePublication(post.updatedAt!) }}
        </time>
      </template>
    </div>
    <PostWaperOpinionContent
      v-if="post.opinion"
      :opinion="post.opinion"
    />
    <ul class="tags">
      <li
        v-if="post.firstTag"
        class="mainTag"
      >
        <NuxtLink :to="`/communautes/${post.firstTag.slug}`">{{
          post.firstTag.title
        }}</NuxtLink>
      </li>
      <li
        v-for="tag in post.tags"
        :key="tag.name"
      >
        {{ tag.name }}
      </li>
    </ul>
    <div class="stats">
      <div
        class="report"
        :class="{ 'is-reported': reported }"
        :aria-disabled="reported || undefined"
        :title="reported ? 'Vous avez déjà signalé ce post' : undefined"
        @click="reportPost"
      >
        <svg
          v-if="reported"
          class="check"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          aria-hidden="true"
        >
          <path d="M2 7.5l3 3 7-7" />
        </svg>
        {{ reported ? 'Post signalé' : 'Signaler ce post' }}
      </div>
      <div
        class="like"
        :class="{ is_liked: post.is_liked }"
        @click="tryLike"
      >
        {{ kFormatter(post.likes) }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.804"
          height="15.731"
          viewBox="0 0 17.804 15.731"
        >
          <path
            d="M17.804 7.615a2.188 2.188 0 0 1-.109.333c-.1.2-.219.383-.323.578a.247.247 0 0 0-.039.178 1.765 1.765 0 0 1-.292 1.8.193.193 0 0 0-.041.218 1.727 1.727 0 0 1-.232 1.683.422.422 0 0 0-.084.387 1.888 1.888 0 0 1-.446 1.853 1.635 1.635 0 0 1-.892.474 5.151 5.151 0 0 1-.915.1H7.655a2.075 2.075 0 0 1-1.143-.373.428.428 0 0 0-.339-.086 2.441 2.441 0 0 1-.027.326.713.713 0 0 1-.654.64 1.408 1.408 0 0 1-.155 0H.827a.763.763 0 0 1-.823-.7V7.928a.795.795 0 0 1 .835-.845h5.088a2.851 2.851 0 0 1 .357.068.243.243 0 0 0 .178-.021 5.533 5.533 0 0 0 .519-.58 23.722 23.722 0 0 0 1.851-3.04 1.1 1.1 0 0 0 .134-.569c-.023-.587-.023-1.176-.047-1.762a.974.974 0 0 1 .515-.927 1.9 1.9 0 0 1 2.063.114 1.176 1.176 0 0 1 .322.475c.219.535.428 1.082.613 1.633a3.532 3.532 0 0 1 .075 1.851c-.093.469-.16.943-.241 1.414-.027.16-.021.178.143.178h3.854a1.649 1.649 0 0 1 .892.212 1.347 1.347 0 0 1 .594.849c.014.055.032.109.048.162v.483Zm-6.457-.963c.139-.826.28-1.633.408-2.441a3.594 3.594 0 0 0 .08-.87 7.146 7.146 0 0 0-.7-2.2.535.535 0 0 0-.4-.357 1.206 1.206 0 0 0-.892.078.319.319 0 0 0-.194.325q.036.974.036 1.947a1.325 1.325 0 0 1-.077.455 3.122 3.122 0 0 1-.26.535c-.535.876-1.07 1.755-1.619 2.62a3.355 3.355 0 0 1-.958 1.07c-.253.164-.508.332-.754.5a.242.242 0 0 0-.1.164v5.289c0 .105.045.116.136.127a2.569 2.569 0 0 1 .506.105 1.4 1.4 0 0 1 .316.191 1.577 1.577 0 0 0 .909.273h6.712a3.057 3.057 0 0 0 .4-.023 1.163 1.163 0 0 0 .824-.476.815.815 0 0 0 .046-1 2.173 2.173 0 0 0-.412-.312.32.32 0 0 1 .114-.123 1.154 1.154 0 0 0 .831-.8.722.722 0 0 0-.228-.829 2.965 2.965 0 0 0-.4-.219.513.513 0 0 1 .159-.153 1.1 1.1 0 0 0 .678-.483.783.783 0 0 0-.357-1.273.155.155 0 0 1-.093-.1.132.132 0 0 1 .114-.148 1.109 1.109 0 0 0 .851-.958.713.713 0 0 0-.389-.822 1.307 1.307 0 0 0-.5-.093h-4.8ZM5.26 7.841c-.057 0-.1-.009-.141-.009H.897a.123.123 0 0 0-.152.153v6.856a.135.135 0 0 0 .166.168h4.166c.178 0 .178 0 .178-.187V7.846Z"
            fill="#363636"
          />
        </svg>
      </div>
      <div
        class="comment"
        @click="clickComment"
      >
        {{ kFormatter(post.commentsCount) }}
        <img
          src="~assets/icons/comment.svg"
          alt="commentaires"
          width="16"
          height="13"
        />
      </div>
      <div
        class="share"
        :class="{ showShare: showShare }"
        @click="showShare = !showShare"
      >
        {{ kFormatter(post.shares) }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.866"
          height="11.931"
          viewBox="0 0 17.866 11.931"
        >
          <path
            d="M12.987,36.781a.4.4,0,0,0,.326-.15,8.9,8.9,0,0,1,5.258-2.7,16.855,16.855,0,0,1,4.031-.275.087.087,0,0,0,.05.025v2.479a.655.655,0,0,0,.376.551.456.456,0,0,0,.526-.125l6.686-5.659a.438.438,0,0,0,0-.7l-6.661-5.283a.64.64,0,0,0-.6-.025.561.561,0,0,0-.3.476v2.454l-.05.05c-7.562,1.4-9.565,5.834-10.066,8.338h0a.439.439,0,0,0,.25.5A.464.464,0,0,0,12.987,36.781Zm9.74-8.388a.59.59,0,0,0,.451-.5v-2.5a.191.191,0,0,1,.125-.05l6.61,5.233-6.661,5.659-.025.025a.19.19,0,0,1-.05-.1v-2.5a.585.585,0,0,0-.476-.5c-.175,0-.5-.025-.926-.025a17.139,17.139,0,0,0-3.255.3,9.678,9.678,0,0,0-5.434,2.729C13.639,33.727,15.642,29.72,22.728,28.393Z"
            transform="translate(-12.549 -24.85)"
            fill="#363636"
          />
        </svg>
      </div>
    </div>
    <ShareItem
      v-if="showShare"
      :share="{
        title: post.title,
        description: post.description,
        slug: post.slug,
        slugType: post.slugType,
      }"
    />
    <div id="comment">
      <div
        v-if="!authenticated"
        class="comment-cta"
      >
        <h2 class="title-strat">commenter cette publication ?</h2>
        <ButtonSimple
          label="Se connecter"
          @click="() => loginModal.open()"
        />
      </div>
      <div
        v-else
        class="editor-comment"
      >
        <h2 class="title-strat">Votre commentaire</h2>
        <div class="comment-section">
          <div
            v-if="auth.data.value?.avatar"
            class="user-image"
          >
            <NuxtImg
              :src="auth.data.value.avatar.url"
              alt=""
              loading="lazy"
              quality="80"
              width="168"
              height="168"
              fit="cover"
              format="auto"
            />
          </div>
          <ClientOnly>
            <div class="editor-content">
              <TheEditor
                ref="editorPost"
                v-model="contentEditor"
                :list="false"
                :mention="true"
                :wapers-suggestions="wapersSuggestions"
              />
              <span
                v-if="errors.content"
                class="c-form__feedback is-invalid"
              >
                {{ errors.content }}
              </span>
            </div>
          </ClientOnly>
        </div>
        <div
          class="button"
          :class="{ disabled: !canComment }"
          @click="submitComment"
        >
          Publier
        </div>
      </div>
    </div>
    <div
      v-if="post.comments?.length"
      class="comments-container"
    >
      <div class="sort-container">
        <div class="sort">
          <select
            v-model="sortReview"
            class="c-form__select"
            @change="onSortChange"
          >
            <option value="date">Trier par date</option>
            <option value="popularity">Trier par popularité</option>
          </select>
        </div>
      </div>
      <PostCommentItem
        v-for="comment in post.comments"
        :key="comment.id"
        :comment="{
          ...comment,
          slugParent: post.slug,
          slugType: post.slugType,
        }"
      />
      <div
        v-if="post.has_more_comments"
        class="more-comments"
        @click="socialStore.showMoreContent()"
      >
        Voir plus de commentaires
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type TheEditorComponent from '@/components/shared/Editor/TheEditor.vue'
import { checkLoginModal } from '@/modals/checkLogin'
import { loginModal } from '@/modals/login'
import { popoutModal } from '@/modals/popout'
import { getReportModal } from '~/modals/report'
import type { PostContent, SocialSortReviews } from '~/types'

// tiptap/ProseMirror (about 100 KB compressed) loaded when an editor is shown, not with the page
const TheEditor = defineAsyncComponent(
  () => import('@/components/shared/Editor/TheEditor.vue'),
)

const props = withDefaults(
  defineProps<{
    post: PostContent
    source?: boolean
  }>(),
  {
    source: false,
  },
)

const showShare = ref(false)
const auth = useAuth()

// a source post sharing a YouTube video (post.url is the watch address, the player is in the page header)
const sharedVideo = computed(
  () => props.source && /youtube\.com|youtu\.be/i.test(props.post.url ?? ''),
)
// the timestamps written under a shared video become chapter links (HeaderSource starts the player there)
const sourceDescription = computed(() => {
  const html = sanitizeUserHtml(props.post.content)
  return sharedVideo.value ? linkifyVideoChapters(html) : html
})
const videoSeek = useVideoSeek()
const onChapterClick = (event: MouseEvent) => {
  const link = (event.target as Element | null)?.closest?.('a.yt-chapter')
  const seconds = startOffset(link?.getAttribute('data-seek'))
  if (!link || seconds === undefined) return
  event.preventDefault()
  videoSeek.value = { seconds, at: Date.now() }
}

// a post edited more than a day after its publication shows both dates
const updatedLater = computed(() => {
  const { createdAt, updatedAt } = props.post
  if (!createdAt || !updatedAt) return false
  return new Date(updatedAt).getTime() - new Date(createdAt).getTime() > 86_400_000
})

const videoInfo = computed(() => {
  return extractVideoId(props.post.urlVideo)
})

useVideoSchema(() => {
  const youtubeId = (url?: string) => {
    const video = extractVideoId(url)
    // findYoutubeId keeps what follows the id in an /embed/<id>?rel=0 URL
    const id =
      video?.source === 'youtube' && video.id.match(/^[A-Za-z0-9_-]{11}/)?.[0]
    return id ? [id] : []
  }

  return {
    ids: [
      ...new Set([
        ...(props.source ? [] : youtubeId(props.post.urlVideo)),
        ...youtubeIdsInHtml(props.post.content),
        ...youtubeId(safeEmbedUrl(props.post.contentEmbed)),
      ]),
    ],
    name: props.post.title,
    description: props.post.description || props.post.content,
    uploadDate: props.post.createdAt,
  }
})

const cover = computed(() => {
  return props.post.urlVideo
    ? buildEmbedUrl(videoInfo.value?.source, videoInfo.value?.id)
    : ''
})

const wapersStore = useWapersStore()
const { userWapers } = storeToRefs(wapersStore)

const wapersSuggestions = computed(() => {
  return userWapers.value.map((waper, index) => {
    return {
      id: index,
      name: waper.nickname,
      userId: waper.id,
      slug: waper.slug,
    }
  })
})

const contentParsed = computed(() => {
  const { contentImages, contentEmbed } = props.post
  let { content } = props.post

  if (contentImages?.length) {
    contentImages.forEach((image, index) => {
      content = content?.replace(
        `<!-- contentImage${index + 1} -->`,
        `<img src="${escapeHtmlAttribute(image.url)}" alt=""> `,
      )
    })
  }

  const embedUrl = safeEmbedUrl(contentEmbed)
  if (embedUrl) {
    content = content?.replace(
      '<!-- contentEmbed -->',
      `<iframe src="${escapeHtmlAttribute(embedUrl)}" frameborder="0" allowfullscreen="true" contenteditable="false" draggable="true"></iframe> `,
    )
  }

  return youtubeFacadeHtml(
    optimizeContentImages(sanitizeUserHtml(linkify(content))),
  )
})

const socialStore = useSocialStore()
const sortReview = ref<SocialSortReviews>('popularity')

const onSortChange = () => {
  socialStore.updateSortComments({
    sort: sortReview.value,
  })
  return socialStore.refreshCommentsAction()
}

const { authenticated } = useAuthenticated()
const editorPost = ref<InstanceType<typeof TheEditorComponent> | null>(null)

const clickComment = () => {
  if (!authenticated.value) {
    return checkLoginModal.open()
  }

  track('social', {
    interaction: 'comment',
    target_url: props.post.slug,
  })

  return editorPost.value?.editor?.commands.focus()
}

const canComment = ref(true)
const contentEditor = ref('')
const errors = ref<{ content?: string }>({})

const submitComment = async () => {
  if (!canComment.value) return
  canComment.value = false
  errors.value = {}

  const formData: {
    content: string
    [key: string]: string | undefined
  } = {
    content: contentEditor.value,
  }

  const images = formData.content.match(
    /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/g,
  )

  if (images?.length) {
    images.forEach((image, index) => {
      formData.content = formData.content.replace(
        image,
        `<!-- contentImage${index + 1} -->`,
      )
      formData[`contentImage${index + 1}`] = image.match(
        /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/,
      )?.[1]
    })
  }

  const embed = formData.content.match(
    /<iframe\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?><\/iframe>/,
  )

  if (embed) {
    formData.content = formData.content.replace(
      embed[0],
      '<!-- contentEmbed -->',
    )
    formData['contentEmbed'] = embed[1]
  }

  const { error } = await socialStore.postCommentContent({
    content: formData,
  })

  if (error) {
    const { statusCode, data } = error

    if (data.errors && statusCode && statusCode >= 400 && statusCode < 500) {
      Object.keys(data.errors).forEach((key) => {
        errors.value = {
          ...errors.value,
          [key]: data.errors[key].join(' '),
        }
      })
    }

    canComment.value = true
    return
  }

  editorPost.value?.editor?.commands.clearContent()
  contentEditor.value = ''
  canComment.value = true
}

const tryLike = () => {
  if (!authenticated.value) {
    return checkLoginModal.open()
  }

  if (props.post.is_liked) {
    return socialStore.unlikeContent()
  }

  return socialStore.likeContent()
}

const tryFollow = () => {
  if (authenticated.value && props.post.user) {
    return socialStore.followWaper(props.post.user.nickname)
  }
  return checkLoginModal.open()
}

const tryUnfollow = () => {
  if (authenticated.value && props.post.user) {
    return socialStore.unfollowWaper(props.post.user.nickname)
  }
}

const route = useRoute()

const reportType = props.post.opinion ? 'bv_review' : 'post'
const reportSlug = route.params.postTitle as string
const reportModal = getReportModal({ type: reportType, slug: reportSlug })

// already reported by this Waper: greyed out, nothing opens (one report per Waper and content)
const { isReported } = useMyWarns()
const reported = computed(() => isReported(reportType, reportSlug))

const reportPost = () => {
  if (reported.value) {
    return
  }
  return authenticated.value ? reportModal.open() : checkLoginModal.open()
}

// Pass the post URL to the popout modal
if (props.post.url) {
  popoutModal.patchOptions({
    attrs: {
      url: props.post.url,
    },
  })
}

// Check if the user is authenticated and if not, open the retention modal (max 1 time per 14 days)
const clickPostLink = (e: PointerEvent) => {
  if (!authenticated.value) {
    const cookie = useCookie<boolean>('pop_out', {
      maxAge: 60 * 60 * 24 * 14,
    })

    if (!cookie.value && props.post.popout) {
      e.preventDefault()
      cookie.value = true
      return popoutModal.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.post-content {
  position: relative;

  .main-iframe {
    iframe,
    .yt-facade {
      display: block;
      width: 100%;
      height: 40rem;
      margin-bottom: 4rem;
    }
  }

  .more-comments {
    padding-top: 1rem;
    padding-bottom: 1rem;
    color: $blue;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
  }

  .bazar-voice {
    top: -6rem;
    bottom: auto;
  }

  .editor-comment {
    display: flex;
    flex-direction: column;
    padding: 3rem 0;

    .comment-section {
      display: flex;
      width: 100%;
      margin-top: 2rem;
    }

    .user-image {
      flex-shrink: 0;
      width: 5.4rem;
      height: 5.4rem;
      margin-right: 3rem;
      overflow: hidden;
      background: #ccc;
      border-radius: 2.7rem;

      @media screen and (max-width: 430px) {
        display: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .editor-content {
      flex-grow: 1;
    }

    .button {
      display: inline-flex;
      align-items: center;
      align-self: flex-end;
      height: 4.6rem;
      margin-top: 3rem;
      padding: 0 2rem;
      color: #fff;
      font-size: 1.5rem;
      font-weight: 500;
      background: $backgroundBlue;
      cursor: pointer;

      &.disabled {
        background-color: $lightGrey;
        cursor: not-allowed;
        opacity: 1;
      }
    }
  }

  .source-content {
    margin-bottom: 4rem;

    .pegi_img {
      margin-left: 1rem;
    }

    .type {
      margin-bottom: 1rem;
      font-size: 1rem;
      font-weight: 500;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      opacity: 0.5;

      span {
        display: none;
      }
    }

    .title {
      margin-bottom: 1.5rem;
      font-size: 3.2rem;
      font-weight: 400;
      line-height: 1.3;
      letter-spacing: 0;
    }

    .pegi {
      width: 3.65rem;
      height: 4.6rem;
    }

    .title-post {
      display: flex;
      justify-content: space-between;
    }

    .description {
      margin-bottom: 1rem;
    }

    .link {
      color: $blue;
      text-decoration: none;
      word-break: break-all;
      overflow-wrap: anywhere;
    }
  }

  .author {
    margin-bottom: 3rem;
    padding-top: 2rem;
    padding-bottom: 3rem;
    border-top: 1px solid rgba(#000, 0.2);
    border-bottom: 1px solid rgba(#000, 0.2);

    .title-strat {
      margin-bottom: 1.8rem;
    }

    .waper {
      display: flex;
      align-items: center;

      .img-container {
        flex-shrink: 0;
        width: 8.4rem;
        height: 8.4rem;
        margin-right: 4rem;
        overflow: hidden;
        background: rgba(#000, 0.2);
        border-radius: 4.2rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .right-content {
        display: flex;
        flex-grow: 1;
        align-items: center;
      }

      .infos-container {
        flex-grow: 1;
        color: $dark;
        text-decoration: none;

        .name {
          font-size: 1.6rem;
          font-weight: bold;
          line-height: 2.1rem;
        }

        .points {
          font-size: 1.4rem;
          font-weight: 300;
          line-height: 1.8rem;
          opacity: 0.5;
        }
      }

      .button-container {
        flex-shrink: 0;

        .button {
          height: 4.6rem;
          padding: 0 2rem;
          color: #fff;
          line-height: 4.6rem;
          cursor: pointer;

          &.no-sub {
            background: $backgroundBlue;

            &:hover {
              background: #0089d8;
            }
          }

          &.sub {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #999;

            img {
              width: 1.1rem;
              height: 1rem;
              margin-left: 1rem;
            }
          }
        }
      }
    }
  }

  .content {
    margin-bottom: 4rem;
  }

  .date {
    margin-bottom: 2rem;
    color: #757575;
    font-size: 1.2rem;
  }

  .tags {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    margin-bottom: 2rem;
    padding: 0;
    list-style: none;

    li {
      height: 1.9rem;
      margin-right: 0.5rem;
      margin-bottom: 0.5rem;
      padding: 0 1.5rem;
      color: #afafaf;
      font-size: 0.8rem;
      font-weight: 500;
      line-height: 1.9rem;
      text-transform: uppercase;
      background: #ebebeb;

      &:last-child {
        margin-right: 0;
      }

      &.mainTag {
        padding: 0;
        color: #fff;
        background: $blue;

        a {
          padding: 0 1.5rem;
          color: #fff;
          font-size: 0.8rem;
          font-weight: 500;
          line-height: 1.9rem;
          text-decoration: none;
        }
      }
    }
  }

  .stats {
    display: flex;
    align-items: center;
    height: 5.7rem;
    border-top: 1px solid rgba(#000, 0.2);
    border-bottom: 1px solid rgba(#000, 0.2);

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 11.6rem;
      height: 100%;
      border-right: 1px solid rgba(#000, 0.2);
      cursor: pointer;

      img,
      svg {
        margin-left: 1.4rem;
      }
    }

    .comments {
      img {
        width: 1.56rem;
        height: 1.317rem;
      }
    }

    .like {
      &.is_liked {
        color: $blue;

        svg {
          path {
            fill: $blue;
          }
        }
      }

      svg {
        width: 1.78rem;
        height: 1.57rem;
      }
    }

    .share {
      img {
        width: 1.787rem;
        height: 1.193rem;
      }

      &:hover {
        color: $blue;

        svg {
          path {
            fill: $blue;
          }
        }
      }

      &.showShare {
        color: #fff;
        background: $blue;

        svg {
          path {
            fill: #fff;
          }
        }
      }
    }

    .report {
      flex-grow: 1;
      justify-content: flex-start;

      &:hover {
        color: $blue;
      }

      &.is-reported,
      &.is-reported:hover {
        color: #a8a8a8;
        cursor: default;
      }

      svg.check {
        margin: 0 0.8rem 0 0;
      }
    }
  }

  .comment-cta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4.4rem;
    margin-bottom: 5rem;
  }

  .sort-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .sort {
    select {
      padding-right: 2rem;
      background-position: right center;
      border: 0;

      &:focus {
        box-shadow: none;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .post-content {
    .stats {
      flex-wrap: wrap;
      height: auto;

      div {
        display: flex;
        flex-grow: 1;
        flex-basis: auto;
        justify-content: center;
        align-items: center;
        width: auto;
        height: 5.7rem;
        border-top: 1px solid rgba(#000, 0.2);

        img {
          margin-left: 1.4rem;
        }
      }

      .report {
        flex-basis: 100%;
        justify-content: center;
        width: 100%;
        border-top: 0;
      }

      .report,
      .like {
        border-left: 1px solid rgba(#000, 0.2);
      }
    }

    .comment-cta {
      flex-direction: column;
      align-items: flex-start;
      margin-top: 2.5rem;
      margin-bottom: 2.5rem;

      .title-strat {
        margin-bottom: 1rem;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .post-content {
    .author {
      .waper {
        .right-content {
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

          .button-container {
            margin-top: 1rem;
          }
        }
      }
    }
  }
}
.post-content .source-content .source-author {
  margin: 8px 0 0;
  font-size: 14px;
  color: #4a5268;

  a {
    color: inherit;
    text-decoration: underline;
  }
}

.post-content .source-content .description a.yt-chapter {
  color: #0072ce;
  text-decoration: underline;
  cursor: pointer;
}
</style>
